import React from "react";
import {
  Parah,
  PointsIcon,
  PointsWrapper,
  SubTitle,
  ThirdTitle,
} from "../ContentsStyles";

const CG_7 = () => {
  return (
    <>
      <Parah>
        We take a firm stance against enabling violence on or off Talents
        Explore. We do not allow people to use our platform to threaten or
        incite violence, or to promote violent extremist organizations,
        individuals, or acts. When there is a threat to public safety or an
        account is used to promote or glorify off-platform violence, we ban the
        account. When warranted, we will report threats to relevant legal
        authorities. To effectively protect our community, we may consider
        off-platform behaviour to identify violent extremist organizations and
        individuals on our platform. If we find such organizations or
        individuals, we will ban their accounts.
      </Parah>
      <SubTitle>Threats and Incitement to Violence</SubTitle>
      <Parah>
        We consider incitement to violence as advocating for, directing, or
        encouraging other people to commit violence. We do not allow threats of
        violence or incitement to violence on our platform that may result in
        serious physical harm.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Statements of intent to inflict physical injuries on an individual or a
        group.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Statements or imagery that encourage others to commit or that advocate
        for violence.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Conditional or aspirational statements that encourage other people to
        commit violence.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Calls to bring weapons to a location with the intent to intimidate or
        threaten an individual or group with violence.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Instructions on how to make or use weapons that may incite violence.
      </PointsWrapper>
      <SubTitle>Violent Extremist Organizations and Individuals</SubTitle>
      <Parah>
        We do not allow organizations or individuals on our platform who promote
        or engage in violence, including terrorist organizations, organized hate
        groups, criminal organizations, and other non-state armed groups that
        target civilians.
      </Parah>
      <ThirdTitle>Terrorist organizations</ThirdTitle>
      <Parah>
        Terrorists and terrorist organizations are non-state actors that
        threaten violence, use violence, and/or commit serious crimes (such as
        crimes against humanity) against civilian populations in pursuit of
        political, religious, ethnic, or ideological objectives.
      </Parah>
      <ThirdTitle>Organized hate groups</ThirdTitle>
      <Parah>
        We use the term “organized hate” to refer to those individuals and
        organizations who attack people based on protected attributes, such as
        race, ethnicity, national origin, religion, caste, sexual orientation,
        sex, gender, gender identity, or immigration status. We consider attacks
        to include actions that incite violence or hatred, that aim to
        dehumanize individuals or groups, or that embrace a hateful ideology.
      </Parah>
      <ThirdTitle>Criminal organizations</ThirdTitle>
      <Parah>
        Criminal organizations are transnational, national, or local groups that
        have engaged in serious crimes, including violent crimes (e.g.,
        homicide, rape, robbery, assault), trafficking (e.g., human, organ,
        drug, weapons), kidnapping, financial crimes (e.g., extortion,
        blackmail, fraud, money laundering), or cybercrime.
      </Parah>
      <ThirdTitle>Do not post, upload, stream, or share:</ThirdTitle>
      <PointsWrapper>
        <PointsIcon />
        Content that praises, promotes, glorifies, or supports violent acts or
        extremist organizations or individuals.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content that encourages participation in, or intends to recruit
        individuals to, violent extremist organizations.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Content with names, symbols, logos, flags, slogans, uniforms, gestures,
        salutes, illustrations, portraits, songs, music, lyrics, or other
        objects meant to represent violent extremist organizations or
        individuals.
      </PointsWrapper>
    </>
  );
};

export default CG_7;
